import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { prefixClass } from './toCssClasses'

class Hidden extends Component {

    makeFullClasses() {
        let classes = []

        const { sizes } = this.props

        if (sizes)
            classes = prefixClass(sizes, 'hidden', classes)

        return classes.join(' ')
    }

    render() {
        return (
            <span className={this.makeFullClasses()}>
                {this.props.children}
            </span>
        )
    }
}

Hidden.propTypes = {
    sizes: PropTypes.string
}

export default Hidden


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Grid/Hidden.js